<template>
  <div
    style="margin-top: 40px; font-weight: bold"
    v-if="!$auth.isAuthenticated"
  >
    Bulk Upload Portal
  </div>
  <BulkUploadCSV v-else></BulkUploadCSV>
</template>

<script>
import BulkUploadCSV from "@/views/BulkUploadCSV";
export default {
  name: "Auth",
  components: {
    BulkUploadCSV,
  },

  created() {
    let vm = this;
    vm.$router.push("/bulk-upload-csv-v2");
  },
};
</script>
